import React from 'react'

const ListingGallery = () => {
  return (
    <div>ListingGallery</div>
  )
}

export default ListingGallery